import { GoalsWrapper } from "./GoalsWrapper";

import { LunchGoal } from "./LunchGoal";
import { EmailTriageGoal } from "./EmailTriageGoal";
import { FocusTimeGoal } from "./FocusTimeGoal";
import { WorkPreferenceGoal } from "./WorkPreferenceGoal";
import { WorkPreferenceStartEndGoal } from "./WorkPreferenceStartEndGoal";
import { MeetingReliefGoal } from "./MeetingReliefGoal";
import { TravelTimeGoal } from "./TravelTimeGoal";

export {
  GoalsWrapper,
  LunchGoal,
  EmailTriageGoal,
  FocusTimeGoal,
  WorkPreferenceGoal,
  WorkPreferenceStartEndGoal,
  MeetingReliefGoal,
  TravelTimeGoal,
};
